/**
 * Front-only access levels shown in the role editor.
 * A level is never persisted; it maps to a bundle of statements via the permission catalogue.
 * Levels are cumulative within a sub-section (each includes the statements of the lower ones).
 */
export enum AccessLevel {
    NONE = 'none',
    READ = 'read',
    EDIT = 'edit',
    // Validation workflow levels (reviews, posts): VALIDATE = manage + submit for validation; PUBLISH = also publish directly.
    VALIDATE = 'validate',
    PUBLISH = 'publish',
}
